// extracted by mini-css-extract-plugin
module.exports = {"brandcolor":"#163194","brandcolor2":"#2699FB","mainbackgroundcolor":"#fff","error":"bc_7"};